var SCM = SCM || {};

(function (ns, $) {
   
    ns.initTestPassword = function (passwordFieldSelector, confirmPasswordFieldSelector, submitBtnSelector) {
        // check for case regex is generated using this site http://apps.timwhitlock.info/js/regex#
        var $checkForCase = /[A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸ-ŹŻŽƁ-ƂƄƆ-ƇƉ-ƋƎ-ƑƓ-ƔƖ-ƘƜ-ƝƟ-ƠƢƤƦ-ƧƩƬƮ-ƯƱ-ƳƵƷ-ƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺ-ȻȽ-ȾɁɃ-ɆɈɊɌɎͰͲͶΆΈ-ΊΌΎ-ΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹ-ϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀ-ӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԱ-ՖႠ-ჅḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾ-ℿⅅↃⰀ-ⰮⱠⱢ-ⱤⱧⱩⱫⱭ-ⱯⱲⱵⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽ-ꝾꞀꞂꞄꞆꞋＡ-Ｚ]|\ud801[\udc00-\udc27]|\ud835[\udc00-\udc19\udc34-\udc4d\udc68-\udc81\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb5\udcd0-\udce9\udd04-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd38-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd6c-\udd85\udda0-\uddb9\uddd4-\udded\ude08-\ude21\ude3c-\ude55\ude70-\ude89\udea8-\udec0\udee2-\udefa\udf1c-\udf34\udf56-\udf6e\udf90-\udfa8\udfca]/,
            $checkForLowerCase = /[a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķ-ĸĺļľŀłńņň-ŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌ-ƍƒƕƙ-ƛƞơƣƥƨƪ-ƫƭưƴƶƹ-ƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜ-ǝǟǡǣǥǧǩǫǭǯ-ǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿ-ɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐ-ϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻ-ϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎ-ӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣա-ևᴀ-ᴫᵢ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶ-ᾷιῂ-ῄῆ-ῇῐ-ΐῖ-ῗῠ-ῧῲ-ῴῶ-ῷⁱⁿℊℎ-ℏℓℯℴℹℼ-ℽⅆ-ⅉⅎↄⰰ-ⱞⱡⱥ-ⱦⱨⱪⱬⱱⱳ-ⱴⱶ-ⱼⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣ-ⳤⴀ-ⴥꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌﬀ-ﬆﬓ-ﬗａ-ｚ]|\ud801[\udc28-\udc4f]|\ud835[\udc1a-\udc33\udc4e-\udc54\udc56-\udc67\udc82-\udc9b\udcb6-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udccf\udcea-\udd03\udd1e-\udd37\udd52-\udd6b\udd86-\udd9f\uddba-\uddd3\uddee-\ude07\ude22-\ude3b\ude56-\ude6f\ude8a-\udea5\udec2-\udeda\udedc-\udee1\udefc-\udf14\udf16-\udf1b\udf36-\udf4e\udf50-\udf55\udf70-\udf88\udf8a-\udf8f\udfaa-\udfc2\udfc4-\udfc9\udfcb]/,
            $checkForSpecialCharacter = /[!"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]/,
            $checkForNumber = /[0-9]/,
            $existingPasswordInput = '',
            $initialPasswordInputWrap = $('.password-input-check-wrap'), // initial password input
            $iconCase = $initialPasswordInputWrap.find('.icon-case'),
            $iconInput = $initialPasswordInputWrap.find('.password-input-icon'),
            $iconLength = $initialPasswordInputWrap.find('.icon-length'),
            $iconNumber = $initialPasswordInputWrap.find('.icon-number'),
            $iconLowerCase = $initialPasswordInputWrap.find('.icon-lower-case'),
            $iconSpecialChar = $initialPasswordInputWrap.find('.icon-special-char'),
            $minSize = 10,
            $passwordValidator = $initialPasswordInputWrap.find('.password-check-wrap'), // the verification card that shows up 
            $passwordConfirmWrap = $('.password-confirm-wrap'), // secondary password input 
            $iconSecondaryConfirm = $passwordConfirmWrap.find('.password-confirm-icon'),
            $validPassword = false;

        $initialPasswordInputWrap.on('keyup', passwordFieldSelector, function () {

            var $currentInputEntry = $(this).val();

            $existingPasswordInput = $currentInputEntry; // for comparison with confirmation input

            // only show requirements if the password doesn't meet them
            $validPassword ? $passwordValidator.hide() : $passwordValidator.show();

            // test the number of characters
            $currentInputEntry.length >= $minSize ? showValidPasswordCriteria($iconLength) : showInvalidPasswordCriteria($iconLength);

            // test for presence of an uppercase character
            $checkForCase.test($currentInputEntry) ? showValidPasswordCriteria($iconCase) : showInvalidPasswordCriteria($iconCase);

            // test for presence of a number
            $checkForNumber.test($currentInputEntry) ? showValidPasswordCriteria($iconNumber) : showInvalidPasswordCriteria($iconNumber);

            // test for presence of an lowercase character
            $checkForLowerCase.test($currentInputEntry) ? showValidPasswordCriteria($iconLowerCase) : showInvalidPasswordCriteria($iconLowerCase);

            // test for presence of an special character
            $checkForSpecialCharacter.test($currentInputEntry) ? showValidPasswordCriteria($iconSpecialChar) : showInvalidPasswordCriteria($iconSpecialChar);

            // if all criteria are met, hide the requirements
            if ($iconLength.hasClass('green') && $iconCase.hasClass('green') && $iconNumber.hasClass('green') && $iconLowerCase.hasClass('green') && $iconSpecialChar.hasClass('green')) {
                $validPassword = true;
                $passwordValidator.fadeOut(500);
                $iconInput.hide();

                // in case current input actually matches the confirm
                if ($currentInputEntry === $initialPasswordInputWrap.find(confirmPasswordFieldSelector).val()) {
                    $initialPasswordInputWrap.find(submitBtnSelector).addClass('btn-green');
                    $initialPasswordInputWrap.find('.register-button-overlay').hide();
                }
            }
            else {
                $validPassword = false;
                $passwordValidator.show();
                lockRegistrationButton();
                $iconInput.show();
            }

            if ($currentInputEntry === '' || $currentInputEntry === null) {
                // hide if input is empty
                $passwordValidator.hide();
                $iconInput.hide();
            }

            var passwordConfirm = $(confirmPasswordFieldSelector).val();
            if (passwordConfirm) {
                validateConfirmPassword(passwordConfirm);
            }
        });

        $passwordConfirmWrap.on('keyup', confirmPasswordFieldSelector, function () {

            var currentConfirmEntry = $(this).val();
            validateConfirmPassword(currentConfirmEntry);
        });

        $(document).on('click', function () {
            $passwordValidator.hide();
        });

        function validateConfirmPassword(currentConfirmEntry) {
            if ($existingPasswordInput === currentConfirmEntry) {
                // passwords match: hide the icon
                $iconSecondaryConfirm.hide();
                if ($validPassword) {
                    // passwords match & are valid: uncover the button
                    $passwordConfirmWrap.find(submitBtnSelector).addClass('btn-green');
                    $passwordConfirmWrap.find('.register-button-overlay').hide();
                }
            } else if (currentConfirmEntry === '' || currentConfirmEntry === null) {
                // empty input: hide the icon, but cover the button
                $iconSecondaryConfirm.hide();
                lockRegistrationButton();
            } else {
                // input doesn't match: show the icon & cover the button
                $iconSecondaryConfirm.show();
                lockRegistrationButton();
            }
        }
    };

    function lockRegistrationButton() {
        var $wrap = $('.register-form-wrap');
        $wrap.find('#registerBtn').removeClass('btn-green');
        $wrap.find('.register-button-overlay').show();
    }

    // for VALID password criteria
    function showValidPasswordCriteria(icon) {
        icon.removeClass('icon-general-close red').addClass('icon-general-check green');
        icon.siblings('.password-check-label').addClass('fade');
    }

    // for INVALID password criteria
    function showInvalidPasswordCriteria(icon) {
        icon.removeClass('icon-general-check green').addClass('icon-general-close red');
        icon.siblings('.password-check-label').removeClass('fade');
    }

})(SCM.TestPassword = SCM.TestPassword || {}, jQuery);
